import Skeleton from '@mui/material/Skeleton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import type { DecoratedOrderTask } from '@witmetrics/utils';
import OrderTasksListItem, {
  type OrderTaskListItemProps,
} from './OrderTasksListItem';
import { classes, styles } from './utils';

export { OrderTasksListItem, type OrderTaskListItemProps };

export type OrderTasksListProps = {
  isFetchingData: boolean;
  condensed?: boolean;
  className?: string;
  orderTasks: DecoratedOrderTask[];
};

export default function OrderTasksList({
  isFetchingData,
  condensed,
  className,
  orderTasks = [],
}: OrderTasksListProps) {
  const sortedTasks = orderTasks.sort((a, b) => {
    if (b.task.dueAt > a.task.dueAt) return -1;
    if (a.task.dueAt > b.task.dueAt) return 1;
    return 0;
  });

  return (
    <List className={className}>
      {isFetchingData
        ? [0, 0.2, 0.3].map((delay) => (
            <ListItem
              key={delay}
              disablePadding
              className={classes.skeletonItem}>
              <Skeleton
                sx={styles.skeleton(delay)}
                className={classes.skeleton}
                variant="rectangular"
                animation="wave"
              />
            </ListItem>
          ))
        : sortedTasks.map((ot) => (
            <OrderTasksListItem
              key={ot.task.id}
              condensed={condensed}
              orderTask={ot}
            />
          ))}
    </List>
  );
}
